$(function() {
  const products = document.querySelectorAll('.product_scroll_hijack');
  let headers = getHeaders();

  const breakpoints = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
    xxl: 5,
  };

  if (products && products.length) {
    initProductPage(products);
  }

  function initProductPage(products) {
    const className = `${mainClassName}--during`;
    const mainClassName = 'product_scroll_hijack';
    const containerId = 'scroll_container';

    Array.from(products).forEach(node => {
      // find the container for all backgrounds
      const container = node.querySelector(`.${mainClassName}__backgrounds`);
      const bgContainer = node.querySelector(
        `.${mainClassName}__backgrounds-container`,
      );
      const {backgrounds, blocks} = prepare(node, bgContainer);
      // this class to change to the active scroll styles
      node.classList.add(`${mainClassName}--active`);
      // PARTAY
      initScrollMagic(backgrounds, blocks, container, bgContainer);
    });

    /*
     * this function prepare the code by moving all backgrounds into a container
     * and returns a list of all said backgrounds but also the content blocks
     */
    function prepare(node, bgContainer) {
      // create a fragment to append backgrounds into
      const backgroundFragment = document.createDocumentFragment();

      const backgrounds = Array.from(
        node.querySelectorAll(`.${mainClassName}__background`),
      );
      const blocks = Array.from(
        node.querySelectorAll(`.${mainClassName}__content`),
      );

      // move backgrounds into fragment
      backgrounds.forEach(node => backgroundFragment.appendChild(node));
      // move fragment on the document
      bgContainer.appendChild(backgroundFragment);

      return {backgrounds, blocks};
    }

    function initScrollMagic(backgrounds, blocks, container, bgContainer) {
      const controllerBG = new ScrollMagic.Controller();
      const controller = new ScrollMagic.Controller();

      const bgScene = new ScrollMagic.Scene({
        triggerElement: container,
        offset: calculateSceneOffset(),
      })
        .setPin(container)
        .addTo(controllerBG);

      window.addEventListener('resize', () => {
        headers = getHeaders();
        bgScene.offset(calculateSceneOffset());
      });

      blocks.forEach((block, index) => {
        const blockContainer = block.querySelector(
          `.${mainClassName}__content-container`,
        );
        const sceneOptions = {
          triggerElement: block,
          offset: calculateBlockOffset(),
          duration: window.innerHeight,
        };

        const scene = new ScrollMagic.Scene(sceneOptions).addTo(controller);

        window.addEventListener('resize', () => {
          scene.offset(calculateSceneOffset());
          scene.duration(window.innerHeight);
        });

        scene.on('leave', ({scrollDirection}) => {
          // can either swap if going down and not last scene OR if going up
          const canSwap = scrollDirection !== 'FORWARD';

          if (canSwap) {
            backgrounds[index].classList.remove('active');
          }
        });

        scene.on('enter', () => {
          backgrounds[index].classList.add('active');
        });

        function calculateBlockOffset() {
          return window.innerHeight / -2 - blockContainer.clientHeight;
        }
      });
    }

    function calculateSceneOffset() {
      return (
        window.innerHeight -
        (window.innerHeight / 2 +
          Array.from(headers).reduce((acc, node) => acc + node.clientHeight, 0))
      );
    }
  }

  function getHeaders() {
    return jQuery('body>nav')
      .filter(':visible')
      .toArray();
  }

});
